export default "__VITE_ASSET__CXrtlLn5__"